import { render, staticRenderFns } from "./account-table.vue?vue&type=template&id=035f6979&scoped=true"
import script from "./account-table.vue?vue&type=script&lang=js"
export * from "./account-table.vue?vue&type=script&lang=js"
import style0 from "./account-table.vue?vue&type=style&index=0&id=035f6979&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f6979",
  null
  
)

export default component.exports